import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ConsolePage, ToolButton } from "../components/console/Console";
import { RONDINES_ROUTE } from "../paths";

// Seguridad y vigilancia → Rondines: los rondines viven ahora en la sub app
// «Rondines» de Bases y Propiedades; aquí queda el enlace.
export default function RondinesLink() {
  const { t } = useTranslation("accessConsole");
  const navigate = useNavigate();
  return (
    <ConsolePage icon="ri-walk-line" title={t("rondines.title")} subtitle={t("rondines.subtitle")}>
      <div className="mx-auto flex max-w-lg flex-col items-center gap-4 rounded-2xl border border-line bg-card p-8 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-500/15 text-2xl text-primary-500">
          <i className="ri-route-line" />
        </span>
        <h2 className="text-lg font-semibold text-content">{t("rondines.moved")}</h2>
        <p className="text-sm text-content-secondary">{t("rondines.movedText")}</p>
        <ToolButton icon="ri-external-link-line" variant="primary" onClick={() => navigate(RONDINES_ROUTE)}>
          {t("rondines.open")}
        </ToolButton>
      </div>
    </ConsolePage>
  );
}
